var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSlackIntegrationIcon = function SvgSlackIntegrationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.909,
    width: 58,
    height: 58,
    rx: 12,
    fill: "#4A154B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#slack-integration-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.906 32.638c0 1.61-1.3 2.91-2.91 2.91s-2.91-1.3-2.91-2.91 1.3-2.91 2.91-2.91h2.91v2.91Zm1.456 0c0-1.61 1.3-2.91 2.91-2.91s2.91 1.3 2.91 2.91v7.275c0 1.61-1.3 2.91-2.91 2.91s-2.91-1.3-2.91-2.91v-7.275Z",
    fill: "#E01E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.271 20.953c-1.61 0-2.91-1.301-2.91-2.91 0-1.61 1.3-2.91 2.91-2.91s2.91 1.3 2.91 2.91v2.91h-2.91Zm0 1.477c1.61 0 2.91 1.3 2.91 2.91s-1.3 2.91-2.91 2.91h-7.297c-1.61 0-2.91-1.3-2.91-2.91s1.3-2.91 2.91-2.91h7.297Z",
    fill: "#36C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.935 25.34c0-1.61 1.3-2.91 2.91-2.91s2.91 1.3 2.91 2.91-1.3 2.91-2.91 2.91h-2.91v-2.91Zm-1.455 0c0 1.61-1.301 2.91-2.91 2.91-1.61 0-2.91-1.3-2.91-2.91v-7.297c0-1.61 1.3-2.91 2.91-2.91 1.609 0 2.91 1.3 2.91 2.91v7.297Z",
    fill: "#2EB67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.57 37.003c1.609 0 2.91 1.3 2.91 2.91s-1.301 2.91-2.91 2.91c-1.61 0-2.91-1.3-2.91-2.91v-2.91h2.91Zm0-1.455c-1.61 0-2.91-1.3-2.91-2.91s1.3-2.91 2.91-2.91h7.297c1.61 0 2.91 1.3 2.91 2.91s-1.3 2.91-2.91 2.91H33.57Z",
    fill: "#ECB22E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "slack-integration-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(15.91 15)",
    d: "M0 0h28v28H0z"
  })))));
};

export default SvgSlackIntegrationIcon;